export default __webpack_public_path__ + "static/media/medical.33ac25bb.jpg";